import { useCallback } from "react";
import { useQueries } from "hooks/useQueries";
import { getPortfolioTradingDetail, getAutoInvesting } from "../service";

export const usePortfolioDetails = (portfolioId) => {
  const fetchTradingDetail = useCallback(async () => {
    return getPortfolioTradingDetail(portfolioId);
  }, [portfolioId]);

  const fetchAutoInvesting = useCallback(async () => {
    const params = {
      broker_account_id: portfolioId,
    };
    return getAutoInvesting(params);
  }, [portfolioId]);

  const result = useQueries({
    queries: [
      {
        queryKey: ["portfolioTradingDetail", portfolioId],
        queryFn: fetchTradingDetail,
        suspense: false,
        enabled: portfolioId !== null,
      },
      {
        queryKey: ["portfolioAutoInvesting", portfolioId],
        queryFn: fetchAutoInvesting,
        suspense: false,
        enabled: portfolioId !== null,
      },
    ],
  });

  return {
    isLoading: result.some((query) => query.isLoading),
    isFetching: result.some((query) => query.isFetching),
    isError: result.some((query) => query.isError),
    error: result.find((query) => query.error)?.error || null,
    data: {
      ...result[0]?.data,
      ...result[1]?.data,
    },
    refetch: () => result.forEach((query) => query.refetch()),
  };
};
